var portfolioEvaluationChart = {
	"3m": "3M",
	"1y": "1A",
	"1stTrade": "Desde la Primera Operación",
	rangeDescription: "Rango {start} a {end}"
};
var es = {
	portfolioEvaluationChart: portfolioEvaluationChart
};

export { es as default, portfolioEvaluationChart };
